import { FDCConcurrences } from '../../../cimsPage/instances/fdc'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const page = FDCConcurrences

const levels = CreateViewEditSoftRemoveRestore({
  page,
  object: 'Concurrence Level',
  view: '59B2CD75-8C43-4827-BF5B-0F9685A86174',
  create: '32EB4889-B02E-4C60-B95B-3A52C9442A2E',
  edit: '23B20B9D-34CB-420F-AF57-A1213DDB5CB4',
  removeRestore: '93E3053F-0621-4AE1-8EBB-03F2DD1B5597',
})

export const ViewFDCConcurrenceLevel = levels.View
export const CreateFDCConcurrenceLevel = levels.Create
export const EditFDCConcurrenceLevel = levels.Edit
export const RemoveRestoreFDCConcurrenceLevel = levels.RemoveRestore

const groups = CreateViewEditSoftRemoveRestore({
  page,
  object: 'Concurrence Group',
  view: 'A7FF1A8A-2BD1-4038-AC10-7B305B22D4B3',
  create: '9A2C51EF-B2F2-4DC1-8041-8E0645B62B5F',
  edit: '34C9F5C2-019D-471F-98B1-B8D3910ED494',
  removeRestore: '89930309-BAEB-45A8-BA7B-0F3562FB8E6A',
})

export const ViewFDCConcurrenceGroup = groups.View
export const CreateFDCConcurrenceGroup = groups.Create
export const EditFDCConcurrenceGroup = groups.Edit
export const RemoveRestoreFDCConcurrenceGroup = groups.RemoveRestore

export type FDCConcurrencePermission =
  | typeof ViewFDCConcurrenceLevel
  | typeof CreateFDCConcurrenceLevel
  | typeof EditFDCConcurrenceLevel
  | typeof ViewFDCConcurrenceGroup
  | typeof CreateFDCConcurrenceGroup
  | typeof EditFDCConcurrenceGroup
  | typeof RemoveRestoreFDCConcurrenceLevel
  | typeof RemoveRestoreFDCConcurrenceGroup
